import moment from 'moment'
import { List } from 'immutable'
import * as actions from './actions'
import { Record } from '../transit'
import { metersPerSecondToKilometersPerHour } from '../../common/lib/utils'

const LOCATION_ITEM_COUNT = 10
const LOCATION_MAX_AGE = 60 * 1000 // limit max age to 1 minute

const Position = Record({
  latitude: null,
  longitude: null,
  accuracy: null,
  timestamp: null,
  speed: null, // meters per seccond
  speedKilometerPerHour: null,
  heading: null, // degrees 0° ≤ heading < 360°, 0 is north
}, 'position')

const Location = Record({
  fine: new List(),
  coarse: new List(),
  current: null,
}, 'location')

const State = Record({
  region: null,
  user: new Location(),
  destination: null,
  isAutoJustifyingEnabled: false,
}, 'map')

const addLocation = (currentLocation, positionData, type) => {
  const position = new Position(Object.assign(
    {},
    positionData.coords,
    positionData,
    { speedKilometerPerHour: metersPerSecondToKilometersPerHour(positionData.coords.speed) },
  ))
  let items = currentLocation.get(type).unshift(position)
  if (items.size >= LOCATION_ITEM_COUNT) items = items.pop()
  let location = currentLocation.set(type, items)

  const latestFinePosition = location.get('fine').first()
  const latestCoarsePosition = location.get('coarse').first()

  const lfTime = (latestFinePosition && moment(latestFinePosition.timestamp)) || null
  const lcTime = (latestCoarsePosition && moment(latestCoarsePosition.timestamp)) || null

  if (!lfTime && !lcTime) return null
  else if (lfTime && !lcTime) {
    location = location.set('current', latestFinePosition)
  } else if (!lfTime && lcTime) {
    location = location.set('current', latestCoarsePosition)
  } else if (lfTime.isBefore(lcTime) || lcTime.diff(lfTime) < LOCATION_MAX_AGE) {
    location = location.set('current', latestFinePosition)
  } else {
    location = location.set('current', latestCoarsePosition)
  }

  return location
}

const mapReducer = (state = new State(), action) => {
  switch (action.type) {

    case actions.MAP_SET_REGION:
      return state.set('region', action.payload.region)

    case actions.MAP_SET_LOCATION: {
      const newLocation = addLocation(state.get('user'), action.payload.location, action.payload.type)
      return state.set('user', newLocation)
    }

    case actions.MAP_SET_DESTINATION: {
      const location = action.payload.location
      return state.set('destination', location)
    }

    case actions.MAP_CLEAR_DESTINATION: {
      return state.set('destination', null)
    }

    case actions.MAP_ENABLE_AUTO_JUSTIFYING: {
      return state.set('isAutoJustifyingEnabled', true)
    }
    case actions.MAP_DISABLE_AUTO_JUSTIFYING: {
      return state.set('isAutoJustifyingEnabled', false)
    }

    default:
      return state
  }
}

export default mapReducer



// WEBPACK FOOTER //
// ./src/common/map/reducer.js